import { FlagBannerNameType } from '../../types/flag.types'

export interface LottoCountryCardProps {
  country: string // Used for small flag rendering
  flagBackgroundName: FlagBannerNameType // Used for background flag rendering
  title: string
  date: string
  time: string
  sections: {
    title: string
    numbers: (number[] | number | string)[]
  }[]
  onClick?: () => void
  isDisabled?: boolean
  lottoType?: LottoType
  noRound?: boolean
}

export enum LottoType {
  STOCK = 'stock',
  GROUP = 'group',
  THAI = 'thai',
}
